const i18nNamespaces = {
  FORM: 'form',
  MEASUREMENT: 'measurement',
} as const;

export default i18nNamespaces;
